<template>
	<div class="login_box">
		<div class="login_content">
			<img src="../../assets/img/login/logo.png" class="login_logo"/>
			<div class="login_left">
				<img src="../../assets/img/login/login_img.png"/>
			</div>
			<div class="login_right">
				<h1>欢迎注册</h1>
				<span>
					<p>手机号<span style="color: red;">*</span></p>
					<input type="text" v-model="form.loginName" placeholder="请输入手机号"  maxlength="11"/>
				</span>
				<span>
					<p>姓名<span style="color: red;">*</span></p>
					<input type="text" v-model="form.xm" placeholder="请输入真实姓名"  maxlength="18"/>
				</span>
				
				<span>
					<p>证件号<span style="color: red;">*</span></p>
					<input type="text" v-model="form.sfzh" placeholder="请输入身份证号"  maxlength="18"/>
				</span>
				<span>
					<p>登录密码<span style="color: red;">*</span></p>
					<input type="password" v-model="form.password" placeholder="请输入登录密码" maxlength="32"/>
				</span>
				<span>
					<p>确认密码<span style="color: red;">*</span></p>
					<input type="password" v-model="form.repassword" placeholder="请再次输入密码" maxlength="32"/>
				</span>
				<span>
					<p>所属机构<span style="color: red;">*</span></p>
					 <select v-model="form.deptId" placeholder="请选择所属机构"  @change="selectClass($event)" style="width: 100%;height:38px;outline:none;border:none; border-bottom: 0.01852rem solid #d7d7d7;font-size:16px">
					        <option value="">请选择所属机构</option>
					        <option value="100">兰州文理学院</option>
							<option value="101">平凉市人社局</option>
							<option value="121">甘肃华开教育科技产业集团有限公司</option>
					</select>
				</span>
				<span style="color: red;">注:密码必须包含数字、字母、特殊符号且大于等于8位小于32位</span>
				<button @click="toRegister">立即注册</button>
			</div>
		</div>
		<div class="clear"></div>
	</div>
</template>

<script>
	import {encrypt,decrypt} from '../../config/jsencrypt'
	import {register} from '@/api/login.js'
	export default{
		data(){
			return{
				form:{
					password:'',
					loginName:'',
					repassword:'',
					deptId:'',
					xm:'',
					sfzh:'',
					
				},
			}
	    },
		methods:{
            selectClass(event){
				if(event.target.value != null && event.target.value != ''){
					this.form.deptId = event.target.value;
				}else{
					this.form.deptId = '';
				}
            },
			toRegister(){
				if(this.form.loginName == null || this.form.loginName==''){
					this.$message.error('手机号必填');
					return;
				}
				if(this.form.xm == null || this.form.xm==''){
					this.$message.error('姓名必填');
					return;
				}
				if(this.form.sfzh == null || this.form.sfzh==''){
					this.$message.error('身份证必填');
					return;
				}
				if(this.form.password == null || this.form.password==''){
					this.$message.error('密码必填');
					return;
				}
				if(this.form.repassword == null || this.form.repassword==''){
					this.$message.error('请再次输入密码');
					return;
				}
				if(this.form.password !=  this.form.repassword){
					this.$message.error('二次输入的密码不一致');
					return;
				}
				if(this.form.deptId == null || this.form.deptId == ''){
					this.$message.error('请选择所属区域');
					return;
				}
			    this.form.password = encrypt(this.form.password);
				this.form.repassword = encrypt(this.form.repassword);
				register(this.form).then(res => {
					console.log("JSON.stringify(obj)" + res + JSON.stringify(res));
					if (res.code == 200) {
						this.$message.success('注册成功');
						this.$router.push('/user/login');
						return;
					}else{
						this.$message.error(res.msg);
					} 
				})
			}
		}
	}
	
</script>

<style lang="less" scoped>
	 .login_box {
	     width: 100%;
	     height: 100vh;
	     background: url(../../assets//img/login/wsgrxx.jpg) no-repeat;
	     background-size: 100% 100%;
	     padding: 10vh 10%;
	     box-sizing: border-box;
	 
	     .login_content {
	         width: 100%;
	         height: 100%;
	         border-radius: 50px;
	         background: #fff;
	         padding: 30px 50px;
	         box-sizing: border-box;
	 
	         .login_logo {
	             width: auto;
	             height: 70px;
	             display: block;
	         }
	         .login_left {
	             width: 55%;
	             height: calc(100% - 80px);
	             display: inline-block;
	             float: left;
	             img {
	                 width: auto;
	                 height: 85%;
	                 margin-top: 5%;
	                 display: block;
	                 margin: 5% auto 0 auto;
	             }
	         }
	         .login_right {
	             width: 41%;
	             margin-left: 4%;
	             margin-bottom: 60px;
	             height: calc(100% - 130px);
	             display: inline-block;
	             float: left;
	             display: flex;
	             align-items: center;
	             flex-wrap: wrap;
	             h1 {
	                 width: 100%;
	                 height: auto;
	                 line-height: 50px;
	                 font-weight: bold;
	                 color: #ff6000;
	                 font-size: 32px;
	                 margin-bottom: 10px;
	             }
	             span {
	                 width: 70%;
	                 height: auto;
	                 display: inline-block;
	                 p {
	                     width: 100%;
	                     height: 30px;
	                     line-height: 30px;
	                     display: inline-block;
	                     font-size: 16px;
	                     color: #909090;
	                 }
	                 input {
	                     width: 100%;
	                     height: 35px;
	                     line-height: 35px;
	                     border: none;
	                     border-bottom: 1px solid #d7d7d7;
	                     font-size: 18px;
	                     color: #333;
	                 }
	             }
	             a {
	                 width: 70%;
	                 height: auto;
	                 line-height: 40px;
	                 display: inline-block;
	                 text-align: right;
	                 color: #ff6a00;
	                 font-size: 16px;
	             }
	             button {
	                 width: 70%;
	                 height: 45px;
	                 border-radius: 60px;
	                 background: linear-gradient(to right, #f4a223, #ff6000);
	                 font-size: 16px;
	                 color: #fff;
	                 border: none;
	             }
	         }
	     }
	 }
	 
</style>
